import { stringToValidValue } from "common/utils/strings";
import { useMatch } from "common/router/hooks";

import { Paths } from "client/routes";

import { OnboardingSubscriptionsStep } from "../types";
import OnboardingSubscriptionsContent from "./OnboardingSubscriptionsContent";

const OnboardingSubscriptionsPage = () => {
  const match = useMatch<Paths["onboarding"]["subscriptions"]["list"]>();
  const step = stringToValidValue(
    match.params.step,
    Object.values(OnboardingSubscriptionsStep),
    OnboardingSubscriptionsStep.List,
  );
  return <OnboardingSubscriptionsContent id={null} step={step} />;
};

export default OnboardingSubscriptionsPage;
